var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 30.645C23.2843 30.645 30 23.9293 30 15.645C30 7.36073 23.2843 0.644989 15 0.644989C6.71574 0.644989 0 7.36073 0 15.645C0 23.9293 6.71574 30.645 15 30.645ZM7.5 12.4625C7.5 10.0817 9.43698 8.14499 11.8175 8.14499H18.1825C20.5633 8.14499 22.5 10.082 22.5 12.4625V18.8858C22.5 21.2664 20.5633 23.2034 18.1825 23.2034H11.8175C9.43674 23.2034 7.5 21.2664 7.5 18.8858V12.4625ZM11.0965 15.6466C11.0965 13.5104 12.8531 11.7726 15.0119 11.7726C17.1707 11.7726 18.9273 13.5104 18.9273 15.6466C18.9273 17.7826 17.1707 19.5203 15.0119 19.5203C12.8529 19.5203 11.0965 17.7826 11.0965 15.6466ZM12.5227 15.6466C12.5227 16.996 13.6392 18.0941 15.0119 18.0941C16.3846 18.0941 17.5012 16.9962 17.5012 15.6466C17.5012 14.297 16.3843 13.1991 15.0119 13.1991C13.6392 13.1991 12.5227 14.297 12.5227 15.6466ZM18.9974 12.5356C19.5062 12.5356 19.9187 12.1232 19.9187 11.6144C19.9187 11.1056 19.5062 10.6931 18.9974 10.6931C18.4886 10.6931 18.0762 11.1056 18.0762 11.6144C18.0762 12.1232 18.4886 12.5356 18.9974 12.5356Z",
    fill: "url(#paint0_linear_468_1013)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_468_1013",
    x1: 3.75,
    y1: 4.39499,
    x2: 26.25,
    y2: 27.8325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE4333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDA110"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.7cad6bbe894f1b2cf0c4621178fb564d.svg";
export { ForwardRef as ReactComponent };